import { render } from "./Login.vue?vue&type=template&id=c04618b8&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=c04618b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c04618b8"

export default script